import { ContainerName } from "../../shared/container/container-name.type.const";

export class EquipmentQuantity {
  constructor(
    private containerName: ContainerName,
    private quantity: number,
  ) {}

  public getName() {
    return this.containerName;
  }

  public getValue() {
    return this.quantity;
  }

  public setValue(param: number) {
    this.quantity = param;
  }

  public toArray(): { name: string; value: number } {
    return { name: this.containerName, value: this.quantity };
  }
}
